var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCompleted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356.871,
    height: 356.871,
    viewBox: "0 0 356.871 356.871",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-346.186 -112.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.195 -61.195)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 168.435,
    cy: 168.435,
    r: 168.435,
    transform: "translate(378.381 184.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,47.381,46.381,84.762,121.144,10",
    transform: "translate(482.18 305.671)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompleted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/completed.6dc8f760.svg";
export { ForwardRef as ReactComponent };